import { twMerge } from "tailwind-merge";
import Type from "@shared/ui/Type";

export type Props = {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
};

export function ProgramResourcesSection({
  title,
  description,
  children,
  className,
}: Props) {
  if (!children) return null;

  return (
    <div
      className={twMerge(
        "w-full max-w-3xl flex flex-col gap-6 md:pr-4",
        className
      )}
    >
      <div className="flex flex-col gap-1">
        <Type variant="h4">{title}</Type>
        <Type variant="body2">{description}</Type>
      </div>
      <div className="flex flex-col gap-6 w-full max-w-2xl">{children}</div>
    </div>
  );
}

export default ProgramResourcesSection;
